import { Dropdown, DropdownButton } from 'react-bootstrap';
import { TSalesInvoice } from './types';
import axiosInstance from './axiosInterceptors';
import { toast } from 'react-toastify';
import { toastConfig } from './toastConfig';
import { AxiosError } from 'axios';

type SalesInvoiceActionsProps = {
  salesInvoiceDetails: TSalesInvoice | null;
  refetch: () => Promise<void>;
  salesInvoiceId: string | undefined;
  branchDomain: string | undefined;
};

const SalesInvoiceActions = ({
  salesInvoiceDetails,
  refetch,
  salesInvoiceId,
  branchDomain
}: SalesInvoiceActionsProps) => {
  const flagForDeletion = async () => {
    try {
      await axiosInstance.put(
        `/api/v1/${branchDomain}/salesInvoices/${salesInvoiceId}/requestToBeDeleted`
      );
      toast.success('Deletion Requested', {
        ...toastConfig,
        autoClose: 2000
      });
      refetch();
    } catch (error) {
      if (error instanceof AxiosError) {
        toast.error(error.response?.data.errorMessage, {
          ...toastConfig,
          autoClose: 3000
        });
      }
    }
  };

  const handleCancelDeletion = async () => {
    try {
      await axiosInstance.put(
        `/api/v1/${branchDomain}/salesInvoices/${salesInvoiceId}/cancelDeletionRequest`
      );
      toast.success('Deletion Request Cancelled', {
        ...toastConfig,
        autoClose: 2000
      });
      refetch();
    } catch (error) {
      if (error instanceof AxiosError) {
        toast.error(error.response?.data.errorMessage, {
          ...toastConfig,
          autoClose: 3000
        });
      }
    }
  };

  return (
    <DropdownButton
      id="dropdown-basic-button"
      title="Actions"
      variant="phoenix-primary"
    >
      {salesInvoiceDetails?.isForDeletion == false && (
        <Dropdown.Item onClick={flagForDeletion}>Delete</Dropdown.Item>
      )}
      {salesInvoiceDetails?.isForDeletion == true && (
        <Dropdown.Item onClick={handleCancelDeletion}>
          Cancel Delete Request
        </Dropdown.Item>
      )}
    </DropdownButton>
  );
};

export default SalesInvoiceActions;
